<script setup lang="ts">
import { watch } from 'vue'
import { useToast } from 'vuestic-ui'
import { useErrorStore } from './stores/error'

const { init: notify } = useToast()
const errorStore = useErrorStore()

watch(
  () => errorStore.errorMessage,
  (message) => {
    if (message) {
      notify({
        message: message,
        color: 'danger',
        duration: 5000,
      })
      errorStore.clearError()
    }
  },
)
</script>

<template>
  <RouterView />
</template>

<style lang="scss">
#app {
  font-family: 'Inter', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  margin: 0;
  min-width: 20rem;
}
</style>
